<!-- eslint-disable vue/multi-word-component-names, no-undef -->
<template>
  <header class="site-header" :class="{ 'site-header-light': light }">
    <router-link to="/" class="site-logo" aria-label="返回首页">
      <img src="/images/logo.svg" alt="鑫谷程序员" />
    </router-link>
    <nav>
      <router-link to="/">首页</router-link>
      <router-link to="/learning-path">学习路线</router-link>
      <router-link to="/teachers">老师介绍</router-link>
      <router-link to="/about">公司简介</router-link>
      <router-link :to="{ path: '/', hash: '#contact' }">联系我们</router-link>
    </nav>
  </header>
</template>
<script setup>
// eslint-disable-next-line no-undef
defineProps({ light: Boolean });
</script>
